import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-actions }}\n{{outlet}}",{ moduleName: "embercom/templates/developer-signup.hbs" })